import { useEffect, useContext, useCallback } from 'react';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import useSessionStorage from '../../hooks/useSessionStorage.js';
import { LearnosityContainerObservable } from '../assessment/LearnosityContainer.js';
import { LEARNOSITY_EVENTS } from '../../scripts/learnosityScripts.js';
import * as PwaEvents from '../../context/PwaEvents.js';
import { TESTER_SAVE_DIALOG } from '../assessment/LearnosityDialogs.js';

const PreviewEventHandler = () => {
  const {
    updateLaunchError,
    setExit,
    setOpenExitingDialog,
    setExitingDialogDetails,
  } = useContext(AssessmentContext);
  const { clearStorage } = useSessionStorage();
  const isPreview = window.location?.pathname?.startsWith('/authorform');
  const testerSaveAndExitSuccess = useCallback(() => {
    const dialog = TESTER_SAVE_DIALOG();
    setExitingDialogDetails(dialog);
    setOpenExitingDialog(true);
  }, [setOpenExitingDialog, setExitingDialogDetails]);

  const eventHandler = useCallback(
    async ({ eventName }) => {
      switch (eventName) {
        case LEARNOSITY_EVENTS.TEST_SUBMIT_SUCCESS:
          //We do not want to exit out of waypoint on test submit success
          //the test:finished:submit will take care of exit
          clearStorage();
          break;
        case PwaEvents.TESTER_SAVEANDEXIT: //This event is generated by NMC custom Save/Exit button
          if (isPreview) {
            window.close(); //close immediately
          } else {
            testerSaveAndExitSuccess();
          }
          break;
        case LEARNOSITY_EVENTS.TEST_FINISHED_SAVE: //This event is generated by Learnosity Save/Exit button
        case LEARNOSITY_EVENTS.TEST_FINISHED_SUBMIT:
          setExit(true);
          break;
        case PwaEvents.LEARNOSITY_LAUNCH_FAIL:
          updateLaunchError(true);
          break;
        default:
          break;
      }
    },
    [
      updateLaunchError,
      testerSaveAndExitSuccess,
      clearStorage,
      setExit,
      isPreview,
    ]
  );

  //UseEffect required. Subscribe and unsubscribe here
  //to make sure the event handler is registered and unregistered
  useEffect(() => {
    //priority on subscribe will call the methods in priority order
    //otherwise it will get invoked in the order of subscription
    LearnosityContainerObservable.subscribe(
      eventHandler,
      'practiceTestEventHandler'
    );
    return () => {
      LearnosityContainerObservable.unsubscribe('practiceTestEventHandler');
    };
  }, [eventHandler]);

  return <></>;
};
export default PreviewEventHandler;
